/**
 * src/shared/youtube.js
 *
 * Normaliza cualquier URL de YouTube al formato embebible (/embed/ID).
 * YouTube rechaza incrustar URLs tipo watch?v=, youtu.be o shorts dentro
 * de un <iframe>: solo acepta https://www.youtube.com/embed/VIDEO_ID.
 */

/** Extrae el ID de video de cualquier formato de URL de YouTube */
export function youtubeId(url) {
    if (!url) return null
    // Ya es un ID suelto (11 caracteres válidos)
    if (/^[a-zA-Z0-9_-]{11}$/.test(url)) return url

    const patterns = [
        /youtu\.be\/([a-zA-Z0-9_-]{11})/,            // youtu.be/ID
        /youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/, // watch?v=ID
        /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,   // embed/ID
        /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,  // shorts/ID
        /youtube\.com\/v\/([a-zA-Z0-9_-]{11})/,       // v/ID
    ]
    for (const re of patterns) {
        const m = url.match(re)
        if (m) return m[1]
    }
    return null
}

/**
 * Devuelve la URL de embed lista para un <iframe>, o la URL original si
 * no es de YouTube (por si se usa Vimeo u otro proveedor con embed directo).
 */
export function youtubeEmbed(url) {
    const id = youtubeId(url)
    return id ? `https://www.youtube.com/embed/${id}` : url
}
